const coverImages = [
	{
		image: 'Parallelität/hecke',
		color: 'rgba(50, 105, 21, 0.7)',
		text: 'Parallelität',
		tag: 'konzept',
		link: 'flat'
	},{
		image: 'Stockholm/stockholm',
		color: 'Firebrick',
		text: 'Stockholm',
		tag: 'report',
		link: 'stockholm'
	},{
		image: 'Routine/Routine',
		color: 'rgba(255, 255, 255, 0.3)',
		text: 'Routine des Lebens',
		tag: 'konzept',
		link: 'routine'
	},{
		image: 'AnalogAlphabet/alphabet_1',
		color: 'saddlebrown',
		text: 'Analog Alphabet',
		tag: 'konzept',
		link: 'alphabet'
	},{
		image: 'Bologna/bologna',
		color: 'Tomato',
		text: 'Bologna',
		tag: 'report',
		link: 'bologna'
	},{
		image: 'Stadthimmel/city',
		color: 'Steelblue',
		text: 'Stadthimmel',
		tag: 'konzept',
		link: 'citysky'
	},{
		image: 'Bilbao/bilbao',
		color: '#E897BC',
		text: 'Bilbao',
		tag: 'report',
		link: 'bilbao'
	},{
		image: 'Berlin/berlin',
		color: '#3BAB95',
		text: 'Berlin',
		tag: 'report',
		link: 'berlin'
	},{
		image: 'Schreibtherapie/past',
		color: 'rgba(0, 0, 0, 0.5)',
		text: 'Schreibtherapie',
		tag: 'konzept',
		link: 'past'
	},{
		image: 'Amsterdam/amsterdam',
		color: '#FFBD20',
		text: 'Amsterdam',
		tag: 'report',
		link: 'amsterdam'
	},{
		image: 'Nachbarschaft/neighbour',
		color: 'rosybrown',
		text: 'Nachbarschaft',
		tag: 'konzept',
		link: 'neighbour'
	},{
		image: 'Barcelona/barcelona',
		color: 'seagreen',
		text: 'Barcelona',
		tag: 'report',
		link: 'barcelona'
	},{
		image: 'White/white',
		color: 'rgba(0, 0, 0, 0.4)',
		text: 'Weißes Tuch',
		tag: 'konzept',
		link: 'white'
	},{
		image: 'Zingst/zingst',
		color: 'thistle',
		text: 'Zingst',
		tag: 'report',
		link: 'zingst'
	},{
		image: 'Schulportrait/school',
		color: '#424A9D',
		text: 'Schulportrait',
		tag: 'konzept',
		link: 'school'
	},{
		image: 'Palma/palma',
		color: 'steelblue',
		text: 'Palma de Mallorca',
		tag: 'report',
		link: 'palma'
	},{
		image: 'Kopenhagen/copenhagen',
		color: 'brown',
		text: 'Kopenhagen',
		tag: 'report',
		link: 'copenhagen'
	}
];

export default coverImages

	//},{
		//image: 'PaperPurse/paperpurse',
		//color: '#F62217',
		//text: 'Paper Purse',
		//tag: 'konzept',
		//link: 'paper'
	//},{
		//image: 'Lost In The Sky/sky',
		//color: '#1F3A69',
		//text: 'Lost In The Sky',
		//tag: 'konzept',
		//link: 'sky'
	//,{
	//	image: 'Malmö/malmoe',
	//	color: '#244C9D',
	//	text: 'Malmö',
	//	tag: 'report',
	//	link: 'malmoe'
	//},{
	//	image: 'GönnDir/goenndir_9',
	//	color: 'darksalmon',
	//	text: 'Gönn Dir',
	//	tag: 'konzept',
	//	link: 'goenndir'
	//}
	//,{
	//	image: 'Farbharmonie/color',
	//	color: '#83C778',
	//	text: 'Farbharmonie',
	//	tag: 'konzept',
	//	link: 'color'
	//}


// WEBPACK FOOTER //
// ./src/components/coverImages.js